import React from 'react';
import InlineLoader from '@adsk/bim360-matrix-react-inline-loader';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';
import PropTypes from 'prop-types';

const ChecklistCell = ({checklistName, onChecklistClick, loadingChecklist, container}) => {
  if (loadingChecklist) {
    return <InlineLoader className="ChecklistCell__loader" />;
  }
  if (checklistName) {
    return (
      <div className="ChecklistCell">
        <OverflowTooltip autoTipOnEllipsis container={container}>
          <span className="ProjectListMatrixTable__checklist-cell" onClick={onChecklistClick}>
            {checklistName}
          </span>
        </OverflowTooltip>
      </div>
    );
  }
  return '-';
};
ChecklistCell.displayName = 'ChecklistCell';

ChecklistCell.propTypes = {
  checklistName: PropTypes.string.isRequired,
  onChecklistClick: PropTypes.func.isRequired,
  loadingChecklist: PropTypes.func.isRequired,
  container: PropTypes.object
};

export default ChecklistCell;
